import sileo from 'sileo';

const StaffConfigurationsTemplate = new sileo.Model('hqzen', 'staff-configurations-template');
const StaffConfigurationsTemplateAdmin = new sileo.Model('hqzen', 'staff-configurations-template-admin');
const RecruitmentStaffConfigurationsTemplate = new sileo.Model('hqzen', 'recruitment-staff-configurations-template');
const EPTApplicantPolicyResource = new sileo.Model('hqzen', 'ept-applicant-policy');
const EmploymentPolicyTemplateList = new sileo.Model('hqzen', 'employment-policy-template-list');
const EPTLeavePolicy = new sileo.Model('hqzen', 'ept-leave-policy');
const EPTPayrollPolicyResource = new sileo.Model('hqzen', 'ept-payroll-policy');
const EPTAppraisalPolicy = new sileo.Model('hqzen', 'ept-appraisal-policy');
const UpdatePlatformSettingsTemplate = new sileo.Model('hqzen', 'change-platform-settings-template');
const EPTOvertimePolicy = new sileo.Model('hqzen', 'ept-overtime-policy');

const actions = {
    fetchEmploymentPolicyTemplateList() {
        return EmploymentPolicyTemplateList.objects.filter();
    },

    fetchLeavePolicy(context, pk) {
        return EPTLeavePolicy.objects.get(pk);
    },

    fetchEPTAppraisalPolicy(context, pk) {
        return EPTAppraisalPolicy.objects.get(pk);
    },

    fetchEPTOvertimePolicy(context,pk) {
        return EPTOvertimePolicy.objects.get(pk);
    },

    fetchDefaultPayrollPolicy(context, pk) {
        return EPTPayrollPolicyResource.objects.get(pk);
    },

    fetchDefaultApplicantPolicy(context, pk) {
        return EPTApplicantPolicyResource.objects.get(pk);
    },

    createStaffConfigurationsTemplate(context, payload) {
        const form = new FormData();

        form.append('staff_configurations_template_name', payload.staff_configurations_template_name);
        form.append('employment_policy_name', payload.employment_policy_name);
        form.append('platform_settings_template_name', payload.platform_settings_template_name);
        form.append('workforce_name', payload.workforce_name);
        form.append('workforce_avatar_uuid', payload.workforce_avatar_uuid);
        form.append('workforce_id', payload.workforce_id);
        form.append('employment_policy_template', payload.employment_policy_template);
        form.append('document_template_id', payload.document_template_id);
        const newPolicyDetailsString = JSON.stringify(payload.new_policy_details);
        form.append('new_policy_details', newPolicyDetailsString);

        return StaffConfigurationsTemplate.objects.create(form);
    },

    createStaffConfigurationsTemplateFromAdministration(context, payload) {
        const form = new FormData();

        form.append('name', payload.name);
        form.append('workforce', payload.workforce);
        form.append('employment_policy', payload.employment_policy);
        form.append('platform_settings_template', payload.platform_settings_template);

        return StaffConfigurationsTemplateAdmin.objects.create(form);
    },

    fetchStaffConfigurationsTemplate(context, filters) {
        return StaffConfigurationsTemplate.objects.filter(filters);
    },

    fetchRecruitmentStaffConfigurationsTemplate(context, filters) {
        return RecruitmentStaffConfigurationsTemplate.objects.filter(filters);
    },

    getStaffConfigurationTemplateDetails(context, pk) {
        return RecruitmentStaffConfigurationsTemplate.objects.get(pk);
    },

    createRecruitmentStaffConfigurationsTemplate(context, payload) {
        const form = new FormData();

        form.append('name', payload.name);
        form.append('workforce', payload.workforce);
        form.append('employment_policy', payload.employment_policy);
        form.append('platform_settings_template', payload.platform_settings_template);

        return RecruitmentStaffConfigurationsTemplate.objects.create(form);
    },

    updatePlatformSettingsTemplate(context, payload) {
        const form = new FormData();

        form.append('workforce', payload.workforce);
        form.append('platform_settings_template', payload.platform_settings_template);

        return UpdatePlatformSettingsTemplate.objects.update({ pk: payload.pk }, form);
    }
};

export default {
    namespaced: true,
    actions,
};
